module.exports = __webpack_public_path__ + "img/UY.19a9158b.png";